module.exports = __webpack_public_path__ + "static/media/intro.cb523bce.m4a";